import React, { useContext, useEffect, useRef, useState } from 'react';
import { Input } from './../styled';
import Select from './Select';
import { cvssOptions } from 'Screens/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper, Container, Title, Error } from './styled';
import { get } from 'lodash';
import { CVSS_TYPES } from './constants';
import { setFiedsError } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import { ThemeContext } from 'Context';
import { CVSS_TYPES_LABELS, getCVSSType, isWrong } from 'Screens/Contextualization/KnowledgeBase/components/VulnTemplateDetail/components/Tabs/components/GeneralTab/components/RiskInformation/components/CVSS/constants';
import { selectTemplates } from 'store/ManageEditCreate/selectors';

const CVSS = ({ manageEditCreate, debouncedSetField, setField }) => {
  const dispatch = useDispatch();
  const isFirstRun = useRef(true);
  const types = cvssOptions.map((option) => option.name);
  const templates = useSelector(selectTemplates);
  const [type, setType] = useState(getCVSSType(manageEditCreate));
  const [vector, setVector] = useState(get(manageEditCreate, `${type}.vector_string`, ''));
  const [error, setError] = useState(isWrong(vector, type));
  const { themeStyles } = useContext(ThemeContext);

  const onChangeInput = (value) => {
    debouncedSetField(type, { vector_string: value });
    dispatch(setFiedsError(false));
    setError(isWrong(value, type));
  };

  const onChangeSelect = (value) => {
    setType(CVSS_TYPES[value]);
  };

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    types.forEach((e) => {
      if (e !== type) {
        dispatch(setFiedsError(false));
        setError(false);
      }
    });
  }, [type]);

  useEffect(() => {
    if (templates.find((e) => e.name === manageEditCreate.name)) {
      setVector(get(manageEditCreate, `${getCVSSType(manageEditCreate)}.vector_string`, ''));
    }
  }, [manageEditCreate.name]);

  return (
      <Wrapper>
        <Title>CVSS Severity Score</Title>
        <Container>
            <Select theme={ themeStyles } updateValue={ (value) => onChangeSelect(value) } defaultValue={ CVSS_TYPES_LABELS[getCVSSType(manageEditCreate)] || '' } />
            <Input
              error={ error }
              className="custom-background"
              width="276px"
              height="38px"
              name="cvss"
              defaultValue={ vector }
              onChange={ (value) => onChangeInput(value) }
            />
        </Container>
        {error && <Error>Invalid format</Error>}
      </Wrapper>
  );
};

export default CVSS;
